module.exports = __webpack_public_path__ + "img/DTIOA.bcaaaf8d.png";